/**
 * Returns a human-readable message for connect/introduction request status.
 * Used in DealPipelineFeature and MyDealNetworkFeature.
 */
export function getIntroductionStatusMessage(statusName: string | null | undefined): string | null {
  if (!statusName) return null;
  switch (statusName.toLowerCase()) {
    case "accepted":
      return "Introduction request accepted.";
    case "dismissed":
      return "Introduction request dismissed.";
    case "pending":
    default:
      return "Introduction request pending.";
  }
}

/**
 * Returns fundraiser-facing next-step guidance for a connect/introduction
 * request status. Written from the fundraiser's perspective — don't reuse
 * on the investor side (DealPipelineFeature) without rewording.
 */
export function getIntroductionStatusDescription(statusName: string | null | undefined): string | null {
  if (!statusName) return null;
  switch (statusName.toLowerCase()) {
    case "accepted":
      return "You're connected! Check your email for the introduction — it includes an invite to a shared WhatsApp group where you can start the conversation with the investor.";
    case "dismissed":
      return "The investor declined this introduction for now. You can send a new request with Retry, or focus on your other matches.";
    case "pending":
    default:
      return "Your request has been sent and is waiting for the investor's response. No action needed from you — once they accept, you'll receive an introduction email with an invite to a shared WhatsApp group.";
  }
}
